export { default as ReportSummaryByAreaPage } from "./View";